import { render, staticRenderFns } from "./PlanCard.vue?vue&type=template&id=b2097e2c"
import script from "./PlanCard.vue?vue&type=script&lang=js"
export * from "./PlanCard.vue?vue&type=script&lang=js"
import style0 from "./PlanCard.vue?vue&type=style&index=0&id=b2097e2c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports